import { render, staticRenderFns } from "./MaintenancePlanDetail.vue?vue&type=template&id=51664d68&scoped=true&"
import script from "./MaintenancePlanDetail.vue?vue&type=script&lang=js&"
export * from "./MaintenancePlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancePlanDetail.vue?vue&type=style&index=0&id=51664d68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51664d68",
  null
  
)

export default component.exports